<template>
    <div>
        <ul class="nav nav-tabs">
            <li class="nav-item" v-for="(item, index) in getMenu" :key="index">
                <a
                    v-if="item.primary"
                    :class="['nav-link', item.id == isActive ? 'active' : '']"
                    @click="changeTab(item.id)"
                    :href="item.href"
                    role="tab"
                    >{{ item.title }}
                    <strong v-if="item.isCompleted" style="color: green"
                        >&#10003;</strong
                    >
                </a>
            </li>
            <li class="nav-item dropdown">
                <a
                    class="nav-link dropdown-toggle"
                    data-toggle="dropdown"
                    href="#"
                    role="button"
                    aria-expanded="false"
                    >Más Opciones</a
                >
                <div class="dropdown-menu">
                    <span v-for="(item, index) in getMenu" :key="index">
                        <a
                            v-if="!item.primary"
                            class="dropdown-item"
                            @click="changeTab(item.id)"
                            :href="item.href"
                            role="tab"
                            >{{ item.title }}
                            <strong v-if="item.isCompleted" style="color: green"
                                >&#10003;</strong
                            >
                        </a>
                    </span>
                </div>
            </li>
        </ul>
        <div class="tab-content">
            <div
                :class="['tab-pane', 0 == isActive ? 'active' : '']"
                id="basic"
                role="tabpanel"
            >
                <contest-form-basic-component
                    v-if="0 == isActive"
                    v-bind:model_id="model_id"
                ></contest-form-basic-component>
            </div>
            <div
                :class="['tab-pane', 1 == isActive ? 'active' : '']"
                id="faq"
                role="tabpanel"
            >
                <contest-faq-component
                    v-if="1 == isActive"
                    v-bind:model_id="model_id"
                ></contest-faq-component>
            </div>
            <div
                :class="['tab-pane', 2 == isActive ? 'active' : '']"
                id="adward"
                role="tabpanel"
            >
                <contest-adward-component
                    v-if="2 == isActive"
                    v-bind:model_id="model_id"
                ></contest-adward-component>
            </div>
            <div
                :class="['tab-pane', 3 == isActive ? 'active' : '']"
                id="ally"
                role="tabpanel"
            >
                <contest-ally-component
                    v-if="3 == isActive"
                    v-bind:model_id="model_id"
                ></contest-ally-component>
            </div>
            <div
                :class="['tab-pane', 5 == isActive ? 'active' : '']"
                id="criteria"
                role="tabpanel"
            >
                <contest-criteria-component
                    v-if="5 == isActive"
                    v-bind:model_id="model_id"
                ></contest-criteria-component>
            </div>
            <div
                :class="['tab-pane', 6 == isActive ? 'active' : '']"
                id="criteria"
                role="tabpanel"
            >
                <contest-requirement-component
                    v-if="6 == isActive"
                    v-bind:model_id="model_id"
                ></contest-requirement-component>
            </div>
            <div
                :class="['tab-pane', 7 == isActive ? 'active' : '']"
                id="category"
                role="tabpanel"
            >
                <contest-category-component
                    v-if="7 == isActive"
                    v-bind:model_id="model_id"
                ></contest-category-component>
            </div>
            <div
                :class="['tab-pane', 8 == isActive ? 'active' : '']"
                id="activity"
                role="tabpanel"
            >
                <contest-activity-component
                    v-if="8 == isActive"
                    v-bind:model_id="model_id"
                ></contest-activity-component>
            </div>
            <div
                :class="['tab-pane', 9 == isActive ? 'active' : '']"
                id="judge"
                role="tabpanel"
            >
                <contest-judge-component
                    v-if="9 == isActive"
                    v-bind:model_id="model_id"
                ></contest-judge-component>
            </div>
            <div
                :class="['tab-pane', 10 == isActive ? 'active' : '']"
                id="home-banner"
                role="tabpanel"
            >
                <contest-home-banner-component
                    v-if="10 == isActive"
                    v-bind:model_id="model_id"
                ></contest-home-banner-component>
            </div>
            <div
                :class="['tab-pane', 11 == isActive ? 'active' : '']"
                id="home-banner"
                role="tabpanel"
            >
                <contest-home-category-component
                    v-if="11 == isActive"
                    v-bind:model_id="model_id"
                ></contest-home-category-component>
            </div>
            <div
                :class="['tab-pane', 12 == isActive ? 'active' : '']"
                id="home-banner"
                role="tabpanel"
            >
                <contest-winner-component
                    v-if="12 == isActive"
                    v-bind:model_id="model_id"
                ></contest-winner-component>
            </div>
            <div
                :class="['tab-pane', 13 == isActive ? 'active' : '']"
                id="home-banner"
                role="tabpanel"
            >
                <contest-what-component
                    v-if="13 == isActive"
                    v-bind:model_id="model_id"
                ></contest-what-component>
            </div>
            <div
                :class="['tab-pane', 14 == isActive ? 'active' : '']"
                id="home-banner"
                role="tabpanel"
            >
                <contest-finalist-component
                    v-if="14 == isActive"
                    v-bind:model_id="model_id"
                ></contest-finalist-component>
            </div>
            <div
                :class="['tab-pane', 15 == isActive ? 'active' : '']"
                id="home-banner"
                role="tabpanel"
            >
                <seo-component
                    v-if="15 == isActive"
                    v-bind:url="'/api/seo/home'"
                    v-bind:parent_id="model_id"
                    v-bind:title_section="'Home SEO'"
                    key="1"
                ></seo-component>
            </div>
            <div
                :class="['tab-pane', 16 == isActive ? 'active' : '']"
                id="home-banner"
                role="tabpanel"
            >
                <seo-component
                    v-if="16 == isActive"
                    v-bind:url="'/api/seo/concepto'"
                    v-bind:parent_id="model_id"
                    v-bind:title_section="'¿Qué es? SEO'"
                    key="2"
                ></seo-component>
            </div>
            <div
                :class="['tab-pane', 17 == isActive ? 'active' : '']"
                id="home-banner"
                role="tabpanel"
            >
                <seo-component
                    v-if="17 == isActive"
                    v-bind:url="'/api/seo/finalistas'"
                    v-bind:parent_id="model_id"
                    v-bind:title_section="'Finalistas SEO'"
                    key="3"
                ></seo-component>
            </div>
            <div
                :class="['tab-pane', 18 == isActive ? 'active' : '']"
                id="question-rating"
                role="tabpanel"
            >
                <question-component
                    v-if="18 == isActive"
                    v-bind:model_id="model_id"
                ></question-component>
            </div>
            <div
                :class="['tab-pane', 19 == isActive ? 'active' : '']"
                id="question-rating"
                role="tabpanel"
            >
                <winner-banner-component
                    v-if="19 == isActive"
                    v-bind:model_id="model_id"
                ></winner-banner-component>
            </div>
            <div
                :class="['tab-pane', 20 == isActive ? 'active' : '']"
                id="config-question"
                role="tabpanel"
            >
                <config-question-component
                    v-if="20 == isActive"
                    v-bind:model_id="model_id"
                ></config-question-component>
            </div>
            <div
                :class="['tab-pane', 21 == isActive ? 'active' : '']"
                id="question-rating-criteria"
                role="tabpanel"
            >
                <question-criteria-component
                    v-if="21 == isActive"
                    v-bind:model_id="model_id"
                ></question-criteria-component>
            </div>
            <div
                :class="['tab-pane', 22 == isActive ? 'active' : '']"
                id="contest-sworn"
                role="tabpanel"
            >
                <contest-sworn-component
                    v-if="22 == isActive"
                    v-bind:model_id="model_id"
                ></contest-sworn-component>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            tab: 0,
            isReadyFaq: false,
            isReadyAdward: false,
            isReadyAlly: false,
            isReadyCriteria: false,
            isReadyRequirement: false,
            isReadyAllCategory: false,
            isReadyActivity: false,
            isReadyJudge: false,
            isReadyHomeBanner: false,
            isReadyHomeCategory: false,
            isReadyHomeWinner: false,
            isReadyBannerWhat: false,
            isReadyBannerFinalist: false,
            isReadyBannerWinnerPage: false,
            isReadyPdf: false,
            isReadyQuestion: false,
        };
    },
    computed: {
        isActive: function () {
            return this.tab;
        },

        getMenu: function () {
            return [
                {
                    id: 0,
                    title: "Datos B.",
                    href: "#basic",
                    isCompleted: false,
                    primary: true,
                },
                {
                    id: 1,
                    title: "Preguntas F.",
                    href: "#faq",
                    isCompleted: this.isReadyFaq,
                    primary: true,
                },
                {
                    id: 2,
                    title: "Premios",
                    href: "#adward",
                    isCompleted: this.isReadyAdward,
                    primary: true,
                },
                {
                    id: 3,
                    title: "Aliados",
                    href: "#ally",
                    isCompleted: this.isReadyAlly,
                    primary: true,
                },
                {
                    id: 5,
                    title: "Criterios",
                    href: "#criteria",
                    isCompleted: this.isReadyCriteria,
                    primary: true,
                },
                {
                    id: 6,
                    title: "Requisitos",
                    href: "#requirment",
                    isCompleted: this.isReadyRequirement,
                    primary: true,
                },
                {
                    id: 7,
                    title: "Categorias",
                    href: "#category",
                    isCompleted: this.isReadyAllCategory,
                    primary: true,
                },
                {
                    id: 8,
                    title: "Calendario",
                    href: "#activity",
                    isCompleted: this.isReadyActivity,
                    primary: true,
                },
                {
                    id: 9,
                    title: "Jurados",
                    href: "#judge",
                    isCompleted: this.isReadyJudge,
                    primary: false,
                },
                {
                    id: 10,
                    title: "Home Banner",
                    href: "#home-banner",
                    isCompleted: this.isReadyHomeBanner,
                    primary: false,
                },
                {
                    id: 11,
                    title: "Home Categorias",
                    href: "#home-banner",
                    isCompleted: this.isReadyHomeCategory,
                    primary: false,
                },
                {
                    id: 12,
                    title: "Home Ganadores",
                    href: "#home-banner",
                    isCompleted: this.isReadyHomeWinner,
                    primary: false,
                },
                {
                    id: 13,
                    title: "¿Qué es? Banner",
                    href: "#home-banner",
                    isCompleted: this.isReadyBannerWhat,
                    primary: false,
                },
                {
                    id: 14,
                    title: "Finalistas Banner",
                    href: "#home-banner",
                    isCompleted: this.isReadyBannerFinalist,
                    primary: false,
                },
                {
                    id: 19,
                    title: "Ganadores Banner",
                    href: "#home-banner",
                    isCompleted: this.isReadyBannerWinnerPage,
                    primary: false,
                },
                {
                    id: 15,
                    title: "Home SEO",
                    href: "#home-banner",
                    isCompleted: false,
                    primary: false,
                },
                {
                    id: 16,
                    title: "¿Qué es? SEO",
                    href: "#home-banner",
                    isCompleted: false,
                    primary: false,
                },
                {
                    id: 17,
                    title: "Finalistas SEO",
                    href: "#home-banner",
                    isCompleted: false,
                    primary: false,
                },
                {
                    id: 21,
                    title: " Criterios de Evaluación",
                    href: "#question-rating-criteria",
                    isCompleted: this.isReadyQuestion,
                    primary: false,
                },
                {
                    id: 18,
                    title: "Preguntas Calificación",
                    href: "#question-rating",
                    isCompleted: this.isReadyQuestion,
                    primary: false,
                },
                {
                    id: 20,
                    title: "Configuración Preguntas",
                    href: "#config-question",
                    isCompleted: false,
                    primary: false,
                },
                {
                    id: 22,
                    title: "Monitor",
                    href: "#config-question",
                    isCompleted: false,
                    primary: false,
                },
            ];
        },
    },
    methods: {
        changeTab(value) {
            if (this.tab != value) {
                this.tab = value;
            }
        }
    },
    mounted() {
        let me = this;
        axios
            .get("/api/contests/has-info-completed?contest_id=" + me.model_id)
            .then(function (response) {
                const { data } = response;
                me.isReadyFaq = data.hasFaq && data.hasSectionFaqs;
                me.isReadyAlly = data.hasAlly && data.hasSectionAlly;
                me.isReadyAdward = data.hasAdward && data.hasSectionAdward;
                me.isReadyCriteria =
                    data.hasCriteria && data.hasSectionCriteria;
                me.isReadyRequirement =
                    data.hasRequirement && data.hasSectionRequirement;
                me.isReadyAllCategory =
                    data.hasAllCategoryCompleted && data.hasSectionCategory;
                me.isReadyActivity =
                    data.hasActivity && data.hasSectionActivity;
                me.isReadyJudge = data.hasJudge && data.hasSectionJudge;
                me.isReadyHomeBanner = data.hasSectionHomeBanner;
                me.isReadyHomeCategory = data.hasSectionHomeCategory;
                me.isReadyHomeWinner = data.hasSectionWinner;
                me.isReadyBannerWhat = data.hasSectionWhat;
                me.isReadyBannerFinalist = data.hasSectionFinalist;
                me.isReadyBannerWinnerPage = data.hasSectionWinnerPage;
                me.isReadyPdf = data?.isReadyPdf;
                me.isReadyQuestion = data.hasQuestion;
            })
            .catch(function (error) {
                console.error(error);
            });
    },
};
</script>
